import { render } from "preact";
import { useRef } from "preact/hooks";
import type { ContactConfig } from "../shared/types.js";
import { trackImpression } from "../shared/tracking.js";
import { ContactForm } from "./contact-form.js";
import css from "../styles/tailwind.css?inline";

function ContactRoot({ config }: { config: ContactConfig }) {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={containerRef} class="max-w-[520px] mx-auto bg-theme-card border border-theme-border rounded-theme font-theme shadow-[0_1px_3px_rgba(0,0,0,0.08)]">
      <ContactForm config={config} containerRef={containerRef} />
    </div>
  );
}

export function renderContact(hostEl: HTMLElement, config: ContactConfig): void {
  let shadow = hostEl.shadowRoot;
  if (shadow) {
    shadow.innerHTML = "";
  } else {
    shadow = hostEl.attachShadow({ mode: "open" });
  }

  const style = document.createElement("style");
  style.textContent = css;
  shadow.appendChild(style);

  const root = document.createElement("div");
  root.style.fontFamily = "system-ui, -apple-system, sans-serif";
  shadow.appendChild(root);

  render(<ContactRoot config={config} />, root);

  (hostEl as any).__fvUnmount = () => render(null, root);
  if (!config.preview) {
    trackImpression(config.embedApiUrl, config.formId, config.embed, config.attribution, hostEl);
  }
}
